import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import { Box, Stack, Typography } from "@mui/material";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GlobalButton from "../../../components/button";
import CustomCheckbox from "../../../components/checkbox";
import ContratcPdfV2 from "../../../components/contractpdf";
import AppHeader from "../../../components/header";
import AppLoader from "../../../components/loader";
import { AppContext } from "../../../lib/Context";
import { baseUrl } from "../../../services";
import {
  createContract,
  sendContractSummary,
  updateContract,
} from "../../../services/ContractApi";
import { updateLeadProposal } from "../../../services/LeadProposalApi";
import {
  areAllKeysFilled,
  calculateUpgradeCharge,
  checkIncludeDateFairUsage,
  checkPlatformUpradeSelected,
  getDataFairUsagePackagesName,
  getTotalServiceChargeOnTarrif,
  getTotalTariffCharges,
  handleOpenSnackBar,
  selectedContractLength,
} from "../../../utils/helper";
import ConfirmContractDialog from "./ConfirmContractDialog";
import ContractPdf from "./ContractPdf";
import { useDispatch, useSelector } from "react-redux";
import { setPhoneValidation } from "../../../lib/redux/slices/phoneValidationSlice";
import { setSignedDate } from "../../../lib/redux/slices/signedDateSlice";
import { getAccessToken } from "../../../services/tokenStore";

const ContractPreview = () => {
  const pdfRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const confirmDialogRef = useRef(null);
  const { state: routerState } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const {
    note,
    allNotes,
    userData,
    isSummarySend,
    setIsSummarySend,
    isContractAccepted,
    setIsContractAccepted,
    cliData,
    generalInfo,
    isBillingEmailSame,
    eBillingAddress,
    downloadSpeed,
    uploadSpeed,
    isReqDebitDetail,
    contractLength,
    debitDetails,
    routerValue,
    paperBillingPrice,
    calculateTotalRevenue,
    calculateGrossProfit,
    calculateOneOfCost,
    calculateOneOfCostProfit,
    handleResetData,
    cordedPhone,
    cordedlessPhone,
    equipments,
    sendType,
    leadProposal,
    setLeadProposal,
    otherProducts,
    setOtherProducts,
    contractEndDate,
    followUpDate,
    isUpfrontPaymentCollected,
    isBankDetailsVerified,
  } = useContext(AppContext);
  const isAdmin = userData?.designation === "Admin" ? true : false;
  const { phoneValidation } = useSelector(
    (state) => state.phoneValidationReducer,
  );
  const { signedDate } = useSelector((state) => state.signedDateReducer);
  const { discount, discountDetails } = useSelector(
    (state) => state.discountReducer,
  );

  const totalOneOfCost = calculateOneOfCost();
  const totalRevenue = calculateTotalRevenue();
  const totalGrossProfit =
    parseFloat(calculateGrossProfit()) + parseFloat(calculateOneOfCostProfit());

  const platFormUpgradeCharge = calculateUpgradeCharge(cliData);
  const totalTarrifCharges = getTotalTariffCharges(cliData);
  const totalAdditionalService = getTotalServiceChargeOnTarrif(cliData);

  // usage
  const isIncludeDateFairUsageInLegacy = checkIncludeDateFairUsage(
    cliData,
    "legacyTariff",
    "legacy"
  );

  const isIncludeDateFairUsageInNgn = checkIncludeDateFairUsage(
    cliData,
    "digitalTariff",
    "ngnValue"
  );

  const dataFairUsagePackagesName = getDataFairUsagePackagesName(cliData);

  const serviceTableData = (params) => {
    return params.map((val) => {
      let obj = {
        number: val.cliNumber ? val.mobileNo || "NA" : "New Connection",
        package: [],
        contractLength: "18 Months",
        liveDate: null,
      };

      if (val.legacyTariff.isSelected) {
        val.lineValues.map((leg) => {
          obj.package.push({
            name: leg?.legacy?.value || "NA",
            amount: leg?.legacy?.salePrice || 0,
            type: "legacy",
            includeDateFairUsage: leg?.legacy?.includeDateFairUsage,
          });
        });
      }

      if (val.digitalTariff.isSelected) {
        val.lineValues.map((leg) => {
          obj.package.push({
            name: leg?.ngnValue?.value || "NA",
            amount: leg?.ngnValue?.salePrice || 0,
            type: "digital",
            includeDateFairUsage: leg?.ngnValue?.includeDateFairUsage,
          });
        });
      }

      const isUpgradeCharge =
        val?.upgradeCharge?.isSelected &&
        val?.upgradeCharge?.isImmediate === false;

      const isMigration =
        val?.migration?.isSelected && val?.migration?.isImmediate === false;

      const isTransfer =
        val?.transfer?.isSelected && val?.transfer?.isImmediate === false;

      if (isUpgradeCharge) {
        obj = {
          ...obj,
          liveDate: val?.upgradeCharge?.liveDate,
        };
      }
      if (isMigration) {
        obj = {
          ...obj,
          liveDate: val?.migration?.liveDate,
        };
      }
      if (isTransfer) {
        obj = {
          ...obj,
          liveDate: val?.transfer?.liveDate,
        };
      }

      return obj;
    });
  };

  const connectionBoxNumber = (params) => {
    return params
      .map((val) => {
        if (val.cliNumber) {
          return val.mobileNo;
        } else {
          return "New Connection";
        }
      })
      .join(" / ");
  };

  const handleDownloadPdf = () => {
    setIsLoading(true);
    const input = pdfRef.current;


    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight; // Move position to the next page
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save("contract-summary.pdf");
      setIsLoading(false);
    });
  };

  const handleSendPdf = async () => {
    if (!selectedContractLength(contractLength)) {
      return handleOpenSnackBar("error", "Please select contract length");
    }

    if (isReqDebitDetail.yes) {
      const debitDetailField = areAllKeysFilled(debitDetails);

      if (!debitDetailField.allFilled) {
        return handleOpenSnackBar(
          "error",
          `${debitDetailField.emptyFields.join(
            ", ",
          )} fields are required for Debit Details`,
        );
      }

      if (!/^\d{6}$/.test(debitDetails?.shortCode?.trim())) {
        return handleOpenSnackBar("error", "The sort code must be 6 digits.");
      }
      if (!/^\d{7,8}$/.test(debitDetails?.accountNumber?.trim())) {
        return handleOpenSnackBar(
          "error",
          "Account number must be 7 or 8 digits only.",
        );
      }

      if (!isBankDetailsVerified) {
        return handleOpenSnackBar("error", "Debit details is not verified");
      }
    }

      const token = getAccessToken();
    

    setIsLoading(true);

    try {
      // Create the PDF document
      const pdfDoc = (
        <ContratcPdfV2
          discountDetails={discountDetails}
          cliData={cliData}
          generalInfo={generalInfo}
          debitDetail={isReqDebitDetail}
          platFormUpgradeCharge={platFormUpgradeCharge}
          routerValue={routerValue}
          cordedPhone={cordedPhone}
          cordedlessPhone={cordedlessPhone}
          equipments={equipments}
          cliMobileNumber={connectionBoxNumber(cliData)}
          totalTarrifCharges={totalTarrifCharges}
          totalAdditionalService={totalAdditionalService}
          serviceTableData={serviceTableData(cliData)}
          selectedContractLength={selectedContractLength(contractLength)}
          isPlatformUpgradeChargeSeleted={checkPlatformUpradeSelected(cliData)}
        />
      );
      const pdfBlob = await pdf(pdfDoc).toBlob();

      //  Initialize FormData and append the data
      const formData = new FormData();
      formData.append("pdf", pdfBlob, "contract_document.pdf");
      formData.append("userEmail", generalInfo?.email);
      formData.append("username", generalInfo?.name);
      formData.append("cpsTerms", discountDetails?.cpsTerms);
      formData.append("businessName", generalInfo?.businessName);

      // Send the FormData to the server
      const res = await axios.post(`${baseUrl}contract/sendPdf`, formData, {
        timeout: 3000000,
        headers: {
          "Content-Type": "multipart/form-data",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (res?.data.status === "success") {
        const creatorId = isAdmin ? generalInfo?.agentId : userData?._id;

        let payload = {
          note,
          generalInfo,
          isBillingEmailSame,
          contractLength: selectedContractLength(contractLength),
          cliData,
          downloadSpeed,
          uploadSpeed,
          routerValue,
          cordedPhone,
          cordedlessPhone,
          equipments,
          paperBillingPrice,
          eBillingAddress,
          isDebitDetails: isReqDebitDetail.yes,
          debitDetails,
          totalRevenue,
          totalOneOfCost,
          totalGrossProfit: totalGrossProfit.toFixed(2),
          contractNote: allNotes,
          // agentId: userData?._id,
          envelopId: res?.data?.data?.envelopeId,
          contractEndDate,
          followUpDate,
          isUpfrontPaymentCollected,
          isBankDetailsVerified,
          phoneDetail: phoneValidation,

          ...(routerState.type == "add" && {
            createdBy: userData?.designation,
            agentId: creatorId,
          }),
          ...(routerState.type == "edit" && { status: "envelope-resend" }),
          ...(isAdmin && { contractSignedAt: signedDate || null }),
          ...(discountDetails && { discountDetails, discount }),
        };

        let resNew;
        if (routerState.type === "add") {
          resNew = await createContract(payload);
        } else {
          resNew = await updateContract(routerState.id, payload);
        }

        if (resNew?.data.status === "success") {
          if (
            routerState.type === "add" &&
            leadProposal.isConverted === true &&
            leadProposal.data !== null
          ) {
            const nested = await updateLeadProposal(leadProposal?.data?._id, {
              status: "Converted",
            });

            if (nested.data.status === "success") {
              setLeadProposal({
                isConverted: false,
                data: null,
              });
            }
          }
          handleResetData(true);
          dispatch(setPhoneValidation(null));
          dispatch(setSignedDate(null));

          navigate("/all-prospects");
          handleOpenSnackBar("success", resNew?.data.message);
        } else {
          handleOpenSnackBar("error", resNew?.data.message);
        }
      } else {
        handleOpenSnackBar("error", res?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendContractSummary = async () => {
    if (selectedContractLength(contractLength) == undefined) {
      return handleOpenSnackBar("error", "Please select contract length");
    }



    try {
      setIsLoading(true);

      let payload = {
        title: generalInfo?.title,
        customerName: generalInfo?.name,
        contractLength: selectedContractLength(contractLength),
        customerEmail: generalInfo?.email,
        isEbillingIncluded: generalInfo.eBilling === "Yes" ? true : false,
        isDebitDetailRequired: isReqDebitDetail.yes,
        totalContractPrice: totalGrossProfit.toFixed(2),
        paperBillingPrice: paperBillingPrice.salePrice,
        downloadSpeed,
        uploadSpeed,
        routerValue,
        cordedPhone,
        cordedlessPhone,
        cliData,
        totalOneOfCost,
        totalPlateFormUpgradeCharge: calculateUpgradeCharge(cliData)?.salePrice,
        isPlatformOptionSeleted: checkPlatformUpradeSelected(cliData),
        equipments,
        totalRevenue,
        isIncludeDateFairUsageInLegacy,
        isIncludeDateFairUsageInNgn,
        dataFairUsagePackagesName,
        ...(discountDetails && { discountDetails, discount }),
      };

      const response = await sendContractSummary(payload);
      if (response?.data.status === "success") {
        handleOpenSnackBar("success", response.data.message);
        setIsSummarySend(true);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue =
  //       "Are you sure you want to reload? All your data will be lost!";
  //     // Set flag in sessionStorage to detect reload
  //     sessionStorage.setItem("reloaded", "true");
  //   };

  //   // Event listener to warn about page reload
  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   // Check if the page was reloaded
  //   if (sessionStorage.getItem("reloaded") === "true") {
  //     sessionStorage.removeItem("reloaded"); // Clear the flag
  //     // Redirect the user to a desired page after reload
  //     if (routerState.type === "edit") {
  //       navigate("/all-prospects"); // Replace "/some-page" with the desired route
  //     } else {
  //       navigate("/add-lead"); // Replace "/some-page" with the desired route
  //     }
  //   }

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />

      {/* <Box width={"100%"} height={"100%"} sx={{ overflow: "auto" }}>
        <PDFViewer
          showToolbar={true}
          style={{ width: "100%", height: "1000px" }}
        >
          <ContratcPdfV2
            discountDetails={discountDetails}
            cliData={cliData}
            generalInfo={generalInfo}
            debitDetail={isReqDebitDetail}
            platFormUpgradeCharge={platFormUpgradeCharge}
            routerValue={routerValue}
            cordedPhone={cordedPhone}
            cordedlessPhone={cordedlessPhone}
            equipments={equipments}
            cliMobileNumber={connectionBoxNumber(cliData)}
            totalTarrifCharges={totalTarrifCharges}
            totalAdditionalService={totalAdditionalService}
            serviceTableData={serviceTableData(cliData)}
            selectedContractLength={selectedContractLength(contractLength)}
            isPlatformUpgradeChargeSeleted={checkPlatformUpradeSelected(
              cliData
            )}
          />
        </PDFViewer>
      </Box> */}

      <Stack
        alignItems={"center"}
        textAlign={"center"}
        spacing={0.5}
        position={"relative"}
        flexWrap={"wrap"}
      >
        <Stack
          gap={1}
          top={0}
          left={{ xs: "10px", sm: "20px" }}
          direction={"row"}
          alignItems={"center"}
          position={"absolute"}
          sx={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          <Typography variant="body1" fontWeight={500} color={"primary.main"}>
            Back
          </Typography>
        </Stack>

        <Typography
          variant="primaryText"
          component={"h1"}
          fontSize={{ xs: "1.5rem", md: "2.125rem" }}
        >
          Contract Preview
        </Typography>
        <Typography variant="secondaryText" component={"p"} maxWidth={500}>
          If you feel some details is wrong and didn’t correct just update it
          and then generate contact to client
        </Typography>
      </Stack>

      <Stack alignItems={"flex-end"} mt={3}>
        <GlobalButton
          variant={"custom_gradient"}
          title={"Download PDF"}
          handleClickBtn={handleDownloadPdf}
          startIcon={
            <VerticalAlignBottomIcon sx={{ color: "secondary.white" }} />
          }
          style={{
            width: "auto",
            borderRadius: 2,
            height: 40,
          }}
        />
      </Stack>

      {/* <Divider sx={{ my: 0 }} /> */}
      <Box mb={4} mt={1}>
        <Box
          ref={pdfRef}
          id={"contract-summary"}
          p={2}
          bgcolor="white"
          border={"1px solid #E0E0E0"}
        >
          <ContractPdf />
        </Box>
      </Box>

      {/* {!isAdmin && ( */}
      <Stack
        my={5}
        direction={"row"}
        alignItems={"center"}
        justifyContent={isSummarySend ? "space-between" : "flex-end"}
      >
        {isSummarySend && (
          <React.Fragment>
            <Stack direction={"row"} alignItems={"center"} spacing={2}>
              <CustomCheckbox
                isChecked={isContractAccepted}
                handleChecked={() => setIsContractAccepted((pre) => !pre)}
              />
              <Typography>Customer agrees to Terms & Conditions</Typography>
            </Stack>

            {isContractAccepted && (
              <GlobalButton
                variant={"custom_gradient"}
                title={"Send Docusign"}
                handleClickBtn={handleSendPdf}
                style={{
                  width: { xs: "100%", sm: 260 },
                  fontSize: "1rem",
                  // borderRadius:"100px"
                }}
              />
            )}
          </React.Fragment>
        )}
        {!isContractAccepted && (
          <GlobalButton
            variant={"custom_gradient"}
            title={"Send contract summary"}
            handleClickBtn={handleSendContractSummary}
            style={{
              width: { xs: "100%", sm: 260 },
              fontSize: "1rem",
            }}
          />
        )}
      </Stack>
      {/* )} */}

      <ConfirmContractDialog ref={confirmDialogRef} />
    </AppHeader>
  );
};

export default ContractPreview;
